module.exports = __webpack_public_path__ + "static/img/LT.21a3a784.jpg";